import React from 'react';
import { FaAward, FaExternalLinkAlt } from 'react-icons/fa';
import { GrCertificate } from 'react-icons/gr';

const CertificateLink = ({ lab, certificate, Certificate_link, useIcon = false, className = 'font-size-sm text-primary', withExternalLinkIcon = false, hideLabName = false, hideCertiNumber = false , GrCerti = false}) => {

  return (
    <a
      href={Certificate_link || null}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {GrCerti && <GrCertificate className="mr-1 font-size-lg" />}
      {useIcon?lab !== "NON"?<FaAward />:"":
      !hideLabName && !hideCertiNumber ?
      `${lab !== "NON"?`${lab}:`:""}${lab !== "NON"?`${certificate}`:"NON-CERTIFIED"}` : 
      !hideLabName?lab !== "NON"?`${lab}`:"":
      !hideCertiNumber?`${lab !== "NON"?`${certificate}`:"NON-CERTIFIED"}`:
      ""}
      {withExternalLinkIcon && lab !== "NON" ? <FaExternalLinkAlt className='ml-1' /> : ""}
    </a>
  )
};

export default CertificateLink;
